module.exports = __webpack_public_path__ + "img/134.e6e2cf35.jpg";